export const getRebateRoutePrefix = () =>
  sessionStorage.getItem('application') === 'Sales Rebate' ? 'sales-rebate' : 'supplier-rebate';

// Contract Management uses hierarchical URLs (module/resource/sub-resource), so its
// results pages can't be built from the flat `${prefix}-${page}-results` pattern.
export const CONTRACT_MANAGEMENT_RESULTS_PATHS = {
  'calculation-simulation': '/contract-management/calculation-simulations/results',
  'calculation-analysis': '/contract-management/calculation-analyses/results',
  'accrual-postings': '/contract-management/accrual-postings/results',
  'settlement-postings': '/contract-management/settlement-postings/results',
  'posted-accruals': '/contract-management/posted-accruals/results',
  'posted-settlements': '/contract-management/posted-settlements/results',
};

// Results page the shared rebate actions navigate to after a successful search.
export const getRebateResultsPath = (page) => {
  if (sessionStorage.getItem('application') === 'Contract Management') {
    return CONTRACT_MANAGEMENT_RESULTS_PATHS[page];
  }
  const prefix = getRebateRoutePrefix();
  if (page === 'calculation-simulation') return `/${prefix}-calculation-simulation-results`;
  if (page === 'calculation-analysis') return `/${prefix}-calculation-analysis-result`;
  return `/${prefix}-${page}-results`;
};
